import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./Theme/Theme.js";

import Navbar        from "./components/Navbar.js";
import LandingPage   from "./Pages/LandingPage.jsx";
import AboutPage     from "./Pages/AboutPage.jsx";
import ServicesPage  from "./Pages/ServicesPage.jsx";
import ContactPage   from "./Pages/ContactPage.jsx";
import VolunteerPage from "./Pages/VolunteerPage.jsx";
import TeamPage      from "./Pages/Teampage.jsx";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />

        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&family=DM+Sans:wght@300;400;500;600&family=Space+Mono:wght@400;700&display=swap');
        `}</style>

        <ScrollToTop />
        <Navbar />

        <Routes>
          <Route path="/"           element={<LandingPage />} />
          <Route path="/about"      element={<AboutPage />} />
          <Route path="/about/team" element={<TeamPage />} />
          <Route path="/services"   element={<ServicesPage />} />
          <Route path="/contact"    element={<ContactPage />} />
          <Route path="/volunteer"  element={<VolunteerPage />} />
        </Routes>

      </ThemeProvider>
    </BrowserRouter>
  );
}